import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PublicLayout as PublicLayoutComponent } from '@/layouts'

/**
 * Public Layout Route (Pathless)
 *
 * Routes under this layout:
 * - /s/:token - Public shared content
 * - Any other public routes that don't require authentication
 *
 * The underscore prefix makes this route pathless - it provides layout
 * without contributing to the URL structure.
 *
 * Layout includes:
 * - Full-screen container (no padding, no chrome)
 * - Minimal logo-only header in top-left corner
 * - No sidebar, no navigation
 * - Optimized for public-facing content viewing
 */
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
})

function PublicLayout() {
  return (
    <PublicLayoutComponent>
      <Outlet />
    </PublicLayoutComponent>
  )
}
